// Lots of VNTG — cart drawer enhancements
(function () {
  'use strict';

  var STAR_FULL = '<svg width="16" height="16" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg"><rect width="40" height="40" rx="3" fill="#00B67A"/><polygon fill="white" points="20,7 23.9,15.4 33,16.6 26.5,22.9 28.2,32 20,27.8 11.8,32 13.5,22.9 7,16.6 16.1,15.4"/></svg>';
  var STAR_EMPTY = '<svg width="16" height="16" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg"><rect width="40" height="40" rx="3" fill="#dcdce6"/><polygon fill="white" points="20,7 23.9,15.4 33,16.6 26.5,22.9 28.2,32 20,27.8 11.8,32 13.5,22.9 7,16.6 16.1,15.4"/></svg>';

  function formatMoney(cents) {
    var euros = cents / 100;
    return '€' + euros.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/,00$/, ',-');
  }

  function addUrgencyBanner() {
    var headers = document.querySelectorAll('#CartDrawer .cart-drawer__header, cart-drawer .cart-drawer__header');
    headers.forEach(function(header) {
      if (header.parentNode.querySelector('.vntg-urgency-banner')) return;
      var banner = document.createElement('div');
      banner.className = 'vntg-urgency-banner';
      banner.innerHTML =
        '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>' +
        '<span><strong>Maar 1 stuk beschikbaar</strong> &mdash; artikelen zijn niet gereserveerd</span>';
      header.parentNode.insertBefore(banner, header.nextSibling);
    });
  }

  function applyCartStyles() {
    document.querySelectorAll('#CartDrawer [name="checkout"], cart-drawer [name="checkout"]').forEach(function(btn) {
      btn.style.setProperty('background-color', '#1a7038', 'important');
      btn.style.setProperty('color', '#fff', 'important');
      btn.style.setProperty('border-color', '#1a7038', 'important');
      btn.style.setProperty('border-radius', '12px', 'important');
      btn.style.setProperty('font-size', '1.5rem', 'important');
      btn.style.setProperty('font-weight', '700', 'important');
      btn.style.setProperty('min-height', '5rem', 'important');
      btn.style.setProperty('padding', '1.2rem 2rem', 'important');
      btn.style.setProperty('flex', '1 1 100%', 'important');
      btn.textContent = 'Veilig afrekenen';
    });
    document.querySelectorAll('#CartDrawer .drawer__footer-buttons .btn--secondary, cart-drawer .drawer__footer-buttons .btn--secondary').forEach(function(btn) {
      btn.style.setProperty('display', 'none', 'important');
    });
    document.querySelectorAll('#CartDrawer .drawer__heading, cart-drawer .drawer__heading').forEach(function(h) {
      h.style.setProperty('width', '100%', 'important');
      h.style.setProperty('justify-content', 'center', 'important');
      h.style.setProperty('text-align', 'center', 'important');
    });
    document.querySelectorAll('#CartDrawer .cart-drawer__header, cart-drawer .cart-drawer__header').forEach(function(h) {
      h.style.setProperty('align-items', 'center', 'important');
    });
  }

  function addTrustpilot() {
    // Insert ABOVE .totals row (boven TOTAAL)
    var totalsEls = document.querySelectorAll('#CartDrawer .totals, cart-drawer .totals');
    totalsEls.forEach(function(totals) {
      var parent = totals.parentNode;
      if (parent.querySelector('.vntg-trustpilot')) return;
      var tp = document.createElement('div');
      tp.className = 'vntg-trustpilot';
      tp.style.cssText = 'display:flex;align-items:center;justify-content:center;gap:6px;padding:0 0 5px;margin:0;';
      tp.innerHTML =
        '<span style="font-size:1.1rem;font-weight:700;color:#191919;">Uitstekend</span>' +
        '<div style="display:flex;gap:2px;">' + STAR_FULL + STAR_FULL + STAR_FULL + STAR_FULL + STAR_FULL + '</div>' +
        '<span style="font-size:1.05rem;font-weight:800;letter-spacing:-0.02em;color:#191919;">Trustpilot</span>';
      parent.insertBefore(tp, totals);
    });
  }

  function removeBadges() {
    document.querySelectorAll('.vntg-savings-badge').forEach(function(el) { el.remove(); });
  }

  function injectBadges() {
    removeBadges();
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (!cart || !cart.items) return;
        cart.items.forEach(function(item) {
          if (!item.compare_at_price || item.compare_at_price <= item.original_price) return;
          var savings = item.compare_at_price - item.original_price;
          if (savings <= 0) return;
          var itemEl = document.querySelector('.cart-item[data-variant-id="' + item.variant_id + '"]');
          if (!itemEl) {
            var allItems = document.querySelectorAll('#CartDrawer .cart-item, cart-drawer .cart-item');
            var prefix = item.product_title.substring(0, 15);
            for (var i = 0; i < allItems.length; i++) {
              var titleEl = allItems[i].querySelector('.cart-item__product a, .cart-item__title');
              if (titleEl && titleEl.textContent.trim().indexOf(prefix) === 0) { itemEl = allItems[i]; break; }
            }
          }
          if (!itemEl || itemEl.querySelector('.vntg-savings-badge')) return;
          var priceEl = itemEl.querySelector('.price--on-sale, .price');
          if (!priceEl) return;
          var badge = document.createElement('div');
          badge.className = 'vntg-savings-badge';
          badge.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0"><polyline points="20 6 9 17 4 12"></polyline></svg> U bespaart ' + formatMoney(savings);
          priceEl.parentNode.insertBefore(badge, priceEl.nextSibling);
        });
      })
      .catch(function() {});
  }

  function applyAll() {
    applyCartStyles();
    addUrgencyBanner();
    addTrustpilot();
    injectBadges();
  }

  var timer;
  function debounced() { clearTimeout(timer); timer = setTimeout(applyAll, 200); }

  applyCartStyles();

  ['cart:updated','cart-drawer:open','cart-drawer:refresh','cart:open','drawer:open'].forEach(function(e) {
    document.addEventListener(e, debounced);
  });

  function setupObserver() {
    var drawer = document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(function(muts) {
      if (muts.some(function(m) { return m.addedNodes.length > 0; })) debounced();
    }).observe(drawer, { childList: true, subtree: true });
    new MutationObserver(function(muts) {
      muts.forEach(function(m) {
        if (m.attributeName === 'hidden' && !drawer.hasAttribute('hidden')) {
          setTimeout(applyAll, 50);
          setTimeout(applyAll, 400);
        }
      });
    }).observe(drawer, { attributes: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { applyAll(); setupObserver(); });
  } else {
    applyAll();
    setupObserver();
  }
})();
